import MetaData from "./MetaData"
export default MetaData
